module.exports = __webpack_public_path__ + "static/media/eva.fda994f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/eva.png
// module id = 2066
// module chunks = 6